import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ssn' })
export class FormatSocialSecurityPipe implements PipeTransform {
  transform(ssn: string | undefined) {
    if (!ssn) {
      return '';
    }
    ssn = ssn.replace(/\D/g, '');
    ssn = ssn.replace(/^(\d{3})/, '$1-');
    ssn = ssn.replace(/-(\d{2})/, '-$1-');
    ssn = ssn.replace(/(\d)-(\d{4}).*/, '$1-$2');

    return ssn;
  }
}
